import script from "./VehicleRequestDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleRequestDialog.vue?vue&type=script&setup=true&lang=js"

import "./VehicleRequestDialog.vue?vue&type=style&index=0&id=70b39b5c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b39b5c"]])

export default __exports__